common.View.create('website.modules.promotions.Index', {

    onDOMLoad() {
        this.initSwiper();
        this.initScrollSpy();
    },

    initSwiper() {
        const swiperCategories = new Swiper('.swiper-categories', {
            // Optional parameters
            direction: 'horizontal',
            loop: false,
            slidesPerView: 'auto',
            spaceBetween: 30,
            breakpoints: {
                640: {
                    slidesPerView: 'auto',
                    spaceBetween: 50,
                },
            },
            freeMode: true,
            watchOverflow: true,

            // If we need pagination
            pagination: {
                el: '.swiper-pagination',
            },

            // Navigation arrows
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            }
        });

        const swiperPromotions = new Swiper('.swiper-promotions', {
            // Optional parameters
            direction: 'horizontal',
            loop: false,
            slidesPerView: 1.5,
            spaceBetween: 20,
            breakpoints: {
                640: {
                    slidesPerView: 2.5,
                    spaceBetween: 25,
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 50,
                },
            },
            freeMode: true,
            watchOverflow: true,

            // If we need pagination
            pagination: {
                el: '.swiper-pagination',
            },

            // Navigation arrows
            navigation: {
                nextEl: '.swiper-promotions-button-next',
                prevEl: '.swiper-promotions-button-prev',
            }
        });
    },

    async initScrollSpy()
    {
        // Get elements for scroll nav
        let mainNavLinks = this.element.find('.swiper-categories a').get(),
            mainSections = this.element.find('.category-section').get(),
            headerHeight = $('header > :visible:first').outerHeight() + this.element.find('.categories-swiper-wrapper').outerHeight() + 100;

        // On scroll
        window.addEventListener('scroll', event => {

            // Get scroll height
            let fromTop = window.scrollY;

            // Go through nav links
            mainNavLinks.forEach(link => {
                // Find section based on css selector
                let sectionItems = $('.website-modules-promotions-Index').find( '[id="' + link.hash.replace( /(-|:|\.|\[|\]|,|=|@)/g, '\\$1' ).replace('#', '') + '"]' ),
                    active = false;

                // Loop items (since multiple canvas can have an id)
                $(sectionItems).each((index, section) => {

                    // Check if scrolled to next section
                    if (
                        section &&
                        fromTop > $(section).offset().top - headerHeight &&
                        fromTop < $(section).offset().top + $(section).outerHeight() -headerHeight
                    ) {
                        active = true;
                    }
                });

                // Check if scrolled to next section
                if ( active ) {
                    // Set active variable
                    link.classList.add('active');
                } else {
                    link.classList.remove('active');
                }
            });
        });

        // Trigger scroll.
        $([document.documentElement, document.body]).animate({
            scrollTop: 1
        }, 1);
    },
});
